import { _, moment, Radio, Backbone } from "../../../../vendor";
import InboomaBaseView from "../../InboomaBaseView";
import InboomaBaseCollectionView from "../../InboomaBaseCollectionView";
import { appCollectionEmptyTpl } from "../../AppAnnouncements";
import { Biscuit, FormatHelper } from "../../../utils";
import PaginationBehavior from "../../../behaviors/Behavior.Pagination";

import WalletTransactionItemTpl from "../../../templates/myInbooma/WalletTransactionItemTpl.html";
import "../../../../vendor/Blob";
import { S3Client } from "aws_js";
import * as FileSaver from "../../../../vendor/FileSaver";

/**
 * @function printDayClosing
 *
 * Calls browser's print dialogue with custom tailored transactionsList,
 * sorted by the used payment_types as requested in #16967
 *
 * Only callable when both location_id AND day-filter have been set
 *
 * @param {Backbone.Collection} transactionsCollection
 */
const printDayClosing = (transactionsCollection) => {
  const t = InboomaBaseView.prototype.t,
    today = moment(),
    location_id = transactionsCollection._filterParams["location_id"];
  if (typeof transactionsCollection._filterParams["begin_gte"] !== "undefined") {
    let begin = moment(transactionsCollection._filterParams["begin_gte"], "YYYY-MM-DD");
  }
  if (typeof transactionsCollection._filterParams["end_lte"] !== "undefined") {
    let end = moment(transactionsCollection._filterParams["end_lte"], "YYYY-MM-DD");
  }

  let title = "";
  let type = t("closing", null, "capital");
  let dates = "";
  if (typeof end === "undefined") {
    if (typeof begin === "undefined") {
      title = t("closing");
      type = title;
    } else {
      title = t("day_closing").replace(" ", "_") + " " + begin.format("DDMMYYYY");
      type = t("day_closing", null, "capital");
      dates = begin.format("dd, DD.MM.YY");
    }
  } else {
    if (begin.format("dd, DD.MM.YY") === end.format("dd, DD.MM.YY")) {
      title = t("day_closing").replace(" ", "_") + " " + begin.format("DDMMYYYY");
      type = t("day_closing", null, "capital");
      dates = begin.format("dd, DD.MM.YY");
    } else {
      title = t("closing") + " " + begin.format("DDMMYYYY") + " - " + end.format("DDMMYYYY");
      dates = begin.format("dd, DD.MM.YY") + " - " + end.format("dd, DD.MM.YY");
      type = t("closing");
    }
  }
  let location_name = "";
  if (typeof location_id !== "undefined") {
    const locationsCollection = Radio.channel("locations").request("get:data"),
      location = locationsCollection.get(location_id);
    location_name = location.get("name");
  }
  let transactionsByPaymentType = {};

  _.each(transactionsCollection.models, (model) => {
    // Map transaction by payment type

    if (typeof transactionsByPaymentType[model.get("payment_type")] === "undefined") {
      transactionsByPaymentType[model.get("payment_type")] = [];
    }

    transactionsByPaymentType[model.get("payment_type")].push(model);
  });

  let totalPerDay = 0;

  const first_name = Biscuit.get("user.first_name"),
    last_name = Biscuit.get("user.last_name"),
    currency = Biscuit.get("client.currency");

  let output = `
        <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                <title>${title}</title>
                <style type="text/css">
                    body { font-family: "Open Sans",Helvetica,Arial,sans-serif; }
                    hode, html, table, thead { width: 100%; }
                    h4 { font-size: 18px; }
                    .printSpacer { height:100px; }
                </style>
                </head>
            <body>
                <p>
                    ${location_name}
                </p>
                <h4 style="float:left;">
                    ${type} 
                    ${dates}
                </h4>
                <p style="float:right;">
                    ${t("created_at")} 
                    ${today.format("DD.MM.YYYY, HH:mm")} 
                    ${t("edited_by")} 
                    ${first_name} ${last_name}
                </p>
                <br /><br />

                <table class="before_print" style="margin-top:30px;">
                <colgroup>
                    <col width="45%" />
                    <col width="55%" />
                </colgroup>
                <thead style="border-bottom:1px solid grey;">
                    <td>${t("payment_type", null, "capital")}</td>
                    <!--<td>${t("date", null, "capital")}</td>-->
                    <td style="text-align:right;">${t("amount", null, "capital")}</td>
                </thead>

                ${_.reduce(
                  transactionsByPaymentType,
                  function (memo, transactions, payment_type) {
                    let totalPerPaymentType = 0;

                    return (
                      memo +
                      `
                        <tr class="sub-headline" style="padding:30px 0;">
                            <td>
                                <h3 style="padding-top:2px;margin-top:9px;">${
                                  payment_type === "null" ? t("misc") : payment_type
                                }</h3>
                            </td>
                        ` +
                      _.reduce(
                        transactions,
                        function (_memo, transaction) {
                          const transactionPrice =
                            transaction.get("debit") !== null || transaction.get("debit") !== 0
                              ? transaction.get("debit")
                              : -transaction.get("credit");

                          totalPerPaymentType += transactionPrice;
                          totalPerDay += transactionPrice;
                          totalPerPaymentType = round(totalPerPaymentType, 2);
                          totalPerDay = round(totalPerDay, 2);
                          return ""; /*_memo + `
                            <tr>
                                <td>${transaction.get('id')}</td>
                                <td>${transaction.get('payment_date')}</td>
                                <td style="text-align:right;">${transactionPrice}${currency}</td>
                                <!--<td>...</td>-->
                            </tr>`; */
                        },
                        "",
                      ) +
                      `
                        <td class="paragraph-sum-total" style="text-align:right;">
                            
                                ${FormatHelper.currencyFormat(totalPerPaymentType)} ${currency}
                                <br />
                        </td>
                    </tr>`
                    );
                  },
                  "",
                )}
                    <tr class="paragraph-sum-total" style="text-align:right;">
                        <td></td>
                        <td>   
                            <br />
                            <hr />
                            ${t("payments_amount_total")}: 
                            <strong>${FormatHelper.currencyFormat(totalPerDay)} ${currency}</strong>
                            <br />
                            <hr />
                        </td>
                    </tr>

                    <tr class="paragraph-sum-total" style="position:absolute;">
                        <td>   
                            <br />
                            <br />
                            ${t("payments_bestand_ist")} ${today.format("DD.MM.YYYY, HH:mm")} ${t(
                              "o_clock",
                            )}:
                            <br />
                        </td>
                        <td></td>
                    </tr>

                    <tr>
                        <td>   
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            ${t("signature", null, "capital")}<br />
                            [${last_name}, ${first_name}]
                            <br />
                        </td>
                    <td></td>
                    </tr>

                    <tr>
                        <td>
                        <td style="text-align:right;color:grey;">
                            inbooma.net
                        </td>
                    </tr>
                </table>
            </body>
        </html>`;

  let rV = -1; // Return value assumes failure.

  if (navigator.appName == "Microsoft Internet Explorer" || navigator.appName == "Netscape") {
    var uA = navigator.userAgent;
    var rE = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");

    if (rE.exec(uA) != null) {
      rV = parseFloat(RegExp.$1);
    } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      /*check for IE 11*/
      rV = 11;
    }
  }

  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

  // Trigger print command to browser
  const printWindow = window.open("", "", "height=700,width=674");

  printWindow.document.body.innerHTML = "";
  printWindow.document.body.innerHTML = output;

  if (rV >= 10 || isChrome) {
    printWindow.document.close(); // necessary for IE >= 10
    printWindow.focus(); // necessary for IE >= 10*
    printWindow.print();
  } else {
    // e.g. Firefox
    setTimeout(() => {
      printWindow.print();
      printWindow.opener.focus();
      printWindow.close();
    }, 0);
  }
};

const round = (wert, dez) => {
  wert = parseFloat(wert);
  if (!wert) return 0;

  dez = parseInt(dez);
  if (!dez) dez = 0;

  var umrechnungsfaktor = Math.pow(10, dez);

  return Math.round(wert * umrechnungsfaktor) / umrechnungsfaktor;
};

const WalletTransactionsListEmptyView = InboomaBaseView.extend({
  template: appCollectionEmptyTpl,
});

const WalletTransactionsListItemView = InboomaBaseView.extend({
  template: WalletTransactionItemTpl,
  className: "inb-c-item-details-row row",
  templateContext: { moment, Biscuit, FormatHelper },
});

export default InboomaBaseCollectionView.extend({
  el: ".inb-wallet-transactions-view-wrapper",
  className: "inb-wallet-item-transactions",
  template: `
        <div id="inb-wallet-transaction-items" class="wallet-transaction-items hide">
            <!-- WalletTransactionsListItemView -->
        </div>

        <div id="saldo-begin-spacer" class="hide" style="width:100%;height:10px;background-color:#ededef;border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3">
        </div>

        <div id="saldo-begin-container" class="inb-c-item-details-row row day-closing-wrapper hide" style="background-color:white;border-bottom:1px solid #e3e3e3;padding-bottom:11px;">
            <div class="medium-12 column" style="font-size:1.05rem;">
                <div id="saldo-date-begin" style="font-size:0.85em;padding-right:8%;display:inline-block;font-weight:bold;"></div>
                <span id="saldo-begin" class="day-closing-total" style="font-size:0.85em;font-weight:bold;float:right;"></span>
            </div>
        </div>
    `,
  emptyView: WalletTransactionsListEmptyView,
  childViewContainer: ".wallet-transaction-items",
  childView: WalletTransactionsListItemView,

  behaviors: [
    {
      behaviorClass: PaginationBehavior,
    },
  ],

  ui: {
    dayClosingWrapper: ".day-closing-wrapper",
    dayClosingTotalSpan: ".day-closing-total",
    dayClosingHeaderSpan: ".day-closing-header",
    printDayClosing: ".print-day-closing",
    saldoEnd: "#saldo-end",
    saldoBegin: "#saldo-begin",
    saldoDateEnd: "#saldo-date-end",
    saldoDateBegin: "#saldo-data-begin",
    accInvoiceLink: ".acc-invoice-link",
  },

  events: {
    "click @ui.printDayClosing": "_printDayClosing",
    "click @ui.accInvoiceLink": "_openAccInvoice",
  },

  templateContext() {
    return {
      clientCurrency: Biscuit.get("client.currency"),
    };
  },

  _openAccInvoice(e) {
    const id = e.target.id.split("acc-invoice-link-")[1];
    // fetch sales billing with corresponding id
    const that = this;
    const RequestHelper = Backbone.Model.extend({
      urlRoot: "/sales_billings?accumulated_invoice_id=" + id,
    });

    new RequestHelper(null).fetch({
      success(model, response) {
        if (response.success && response.data.length > 0) {
          that._readFile(response.data[0]);
        } else {
          console.log("ERROR: failed to get sales billings response");
        }
      },
      error(model, response) {
        console.log("Error, could not request sales billing.");
      },
    });
  },

  _readFile(sales_billing) {
    const file_name = sales_billing.file;

    S3Client.getDocument(
      Number(Biscuit.get("user.client_id")),
      "SalesBilling",
      sales_billing.location_id,
      file_name,
    )
      .then((data) => {
        const blob = new Blob([data.Body], { type: data.ContentType });
        FileSaver.saveAs(blob, file_name.replace(/_/gi, " "));
      })
      .catch((err) => {
        alert(`Error downloading file: ${err}`);
      });
  },

  _printDayClosing() {
    if (this.collection._pagination.has_next_page) {
      // show warning - not all transactions loaded
      if (!confirm(this.t("incomplete_transactions_warning"))) {
        return false;
      } else {
        printDayClosing(this.collection);
        return false;
      }
    }
    printDayClosing(this.collection);
    return false;
  },

  _computePreviousSaldo() {
    const currentSaldo = this.collection._saldo;

    let total = 0;
    _.each(this.collection.models, (model) => {
      if (model.get("credit") > 0) {
        total += model.get("credit");
      }
      if (model.get("debit") > 0) {
        total -= model.get("debit");
      }
    });
    return currentSaldo - total;
  },

  onRenderChildren() {
    // After rendering all childViews, check for active "payment_day" AND "location_id"
    // filter, then calculate total sum for that day and display it
    let managerHasLocations = Biscuit.get("user.user_locations");
    if (this.collection.models.length > 0) {
      /*
            // Set and show wrapper
            const totalPricePerDay = _.reduce(this.collection.models, (memo, model) => {
                return memo + (model.get('debit') !== null && model.get('debit') !== 0
                                ? model.get('debit')
                                : - model.get('credit'));
            }, 0);

          //  this.getUI('dayClosingTotalSpan')[0].innerHTML = totalPricePerDay;

           // const activeDays = moment(this.collection._filterParams['payment_begin_gte'],'YYYY-MM-DD') + ' - ' + moment(this.collection._filterParams['payment_end_lte'],'YYYY-MM-DD');
            let begin = null,
                end = null;
            if(typeof this.collection._filterParams['begin_gte'] !== 'undefined') {
                 begin = moment(this.collection._filterParams['begin_gte'], 'YYYY-MM-DD');
            }
            if(typeof this.collection._filterParams['end_lte'] !== 'undefined') {
                 end = moment(this.collection._filterParams['end_lte'],'YYYY-MM-DD');
            }

             let type = '',
                 dates = '';
            if(end === null){
                if(begin === null){
                    type = "";
                } else {
                    dates = begin.format('dd, DD.MM.YY');
                    type = this.t('day_closing_total_${a}', {a:dates});
                }
            } else {
                if(begin.format('dd, DD.MM.YY') === end.format('dd, DD.MM.YY')){
                    dates = begin.format('dd, DD.MM.YY');
                    type = this.t('day_closing_total_${a}', {a:dates});
                } else {
                    dates = begin.format('dd, DD.MM.YY') + ' - ' + end.format('dd, DD.MM.YY');
                    type = this.t('closing_total_${a}', {a:dates});
                }
            }
            this.getUI('dayClosingHeaderSpan')[0].innerHTML = "";

            this.getUI('dayClosingWrapper')[0].classList.remove('hide');
            if(type !== ""){
                type += ": ";
            }
            */
      //this.getUI('dayClosingTotalSpan')[0].innerHTML = type + FormatHelper.currencyFormat(totalPricePerDay);

      let begin = null,
        end = null;
      if (typeof this.collection._filterParams["begin_gte"] !== "undefined") {
        begin = moment(this.collection._filterParams["begin_gte"], "YYYY-MM-DD");
      }
      if (typeof this.collection._filterParams["end_lte"] !== "undefined") {
        end = moment(this.collection._filterParams["end_lte"], "YYYY-MM-DD");
      } else {
        end = moment();
      }
      document.getElementById("saldo-date-end").innerHTML = this.t("saldo_from_${a}", {
        a: end.format("DD.MM.YYYY"),
      });
      document.getElementById("saldo-end").innerHTML =
        FormatHelper.currencyFormat(this.collection._saldo) + " " + Biscuit.get("client.currency");
      document.getElementById("saldo-date-begin").innerHTML = this.t("previous_saldo");
      document.getElementById("saldo-begin").innerHTML =
        FormatHelper.currencyFormat(this._computePreviousSaldo()) +
        " " +
        Biscuit.get("client.currency");
    } else {
      // Hide wrapper
      //this.getUI('dayClosingWrapper')[0].classList.add('hide');
    }
  },

  initialize() {
    this.collection._pending = true;
    this.collection._isTransactionCollection = true;
    this.collection._saldo = 0;

    // set up saldo bar above sort tabs

    let sortTabs = document.getElementById("inb-c-main-sort-nav");
    sortTabs.classList.add("hide");
    let topSaldoBar = document.createElement("div");
    topSaldoBar.style =
      "width: 100%;height:50px;background-color:white;padding-top:3px;padding-left:15px;border-bottom:1px solid #e3e3e3;font-size:0.85em;font-weight:bold;";
    topSaldoBar.className = "hide";
    topSaldoBar.id = "top-saldo-bar";
    let topSaldoBarContent = document.createElement("div");
    topSaldoBarContent.id = "top-saldo-bar-content";
    topSaldoBarContent.className = "inb-c-item-details-row row day-closing-wrapper hide_";
    topSaldoBarContent.style.backgroundColor = "white";
    let topSaldoBarColumnLeft = document.createElement("div");
    let topSaldoBarColumnMiddle = document.createElement("div");
    let topSaldoBarColumnRight = document.createElement("div");
    topSaldoBarColumnLeft.className = "medium-4 column";
    topSaldoBarColumnMiddle.className = "medium-4 column";
    topSaldoBarColumnRight.className = "medium-4 column text-right";
    topSaldoBarColumnLeft.innerHTML =
      '<span id="saldo-date-end" class="day-closing-header"></span>';
    topSaldoBarColumnMiddle.style = "text-align:center;";
    topSaldoBarColumnMiddle.innerHTML =
      '<a href="#" class="print-day-closing" style="text-decoration:underline;" title="Aktuelle gefilterte Auswahl als Tagesabschluss drucken">Abschluss drucken</a>';
    topSaldoBarColumnRight.style = "font-size: 0.95rem;";
    topSaldoBarColumnRight.innerHTML = '<span id="saldo-end"></span>';

    let topSaldoBarSpacer = document.createElement("div");
    topSaldoBarSpacer.style =
      "width: 100%;height: 10px;background-color: white;background-color: #ededef;border-bottom: 1px solid #e3e3e3";

    topSaldoBarContent.appendChild(topSaldoBarColumnLeft);
    topSaldoBarContent.appendChild(topSaldoBarColumnMiddle);
    topSaldoBarContent.appendChild(topSaldoBarColumnRight);
    topSaldoBar.appendChild(topSaldoBarContent);

    sortTabs.parentNode.insertBefore(topSaldoBar, sortTabs);
    sortTabs.parentNode.insertBefore(topSaldoBarSpacer, sortTabs);

    // bind day closing button to event handler
    document.getElementsByClassName("print-day-closing")[0].addEventListener("click", () => {
      that._printDayClosing();
    });

    this.render();

    const that = this;
    this.collection.bind("add", () => {
      if (that.collection._pending === true) {
        that.collection._pending = false;
        document
          .getElementsByClassName("inb-wallet-transactions-view-wrapper")[0]
          .classList.remove("hide");
        document.getElementById("inb-loader-container").classList.add("hide");
        //document.getElementById('top-saldo-bar-content').classList.remove('hide');
        if (this.collection.length > 0) {
          document.getElementById("top-saldo-bar").classList.remove("hide");
          document.getElementById("inb-c-main-sort-nav").classList.remove("hide");
          document.getElementById("saldo-begin-spacer").classList.remove("hide");
          document.getElementById("saldo-begin-container").classList.remove("hide");
        }
      }
      document.getElementsByClassName("inb-next-page-button")[0].classList.remove("hide");
      document.getElementById("inb-wallet-transaction-items").classList.remove("hide");
    });
    this.collection.bind("reset", () => {
      document
        .getElementsByClassName("inb-wallet-transactions-view-wrapper")[0]
        .classList.add("hide");
      document.getElementsByClassName("inb-next-page-button")[0].classList.add("hide");
      document.getElementById("inb-loader-container").className = "";
      //document.getElementById('top-saldo-bar-content').classList.add("hide");
      document.getElementById("top-saldo-bar").classList.add("hide");
      document.getElementById("inb-c-main-sort-nav").classList.add("hide");
      document.getElementById("saldo-begin-spacer").classList.add("hide");
      document.getElementById("saldo-begin-container").classList.add("hide");
    });
  },
});
